var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-space"},[_c('div',{staticClass:"label is-small"},[_vm._v(_vm._s(_vm.initBlock.config.label))]),_c('vue-editor',{attrs:{"value":_vm.initBlock.value.text,"editorOptions":_vm.editorOptions},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }